import React, { HTMLAttributes } from 'react';

const DocumentDownload = ({
  className,
}: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <path d="M19.969 0H8.25a.473.473 0 0 0-.331.137L3.23 4.825a.473.473 0 0 0-.137.331v16.032c0 .517.42.937.937.937h5.703l1.598 1.599a.942.942 0 0 0 1.336 0l1.599-1.599h5.702c.517 0 .938-.42.938-.937V.938A.939.939 0 0 0 19.969 0ZM7.781 1.6v3.088H4.695L7.782 1.6Zm4.224 21.46a.007.007 0 0 1-.01 0l-2.798-2.797-.002-.006c0-.003.003-.007.007-.007h.923a.47.47 0 0 0 .469-.468v-3.376h2.812v3.376c0 .259.21.468.47.468h.923c.003 0 .004.001.005.003a.007.007 0 0 1 0 .01l-2.799 2.798Zm7.964-1.872h-4.765l.263-.263a.946.946 0 0 0-.668-1.612h-.455v-2.907a.939.939 0 0 0-.938-.937h-2.812a.939.939 0 0 0-.938.937v2.907h-.454a.946.946 0 0 0-.666 1.615l.26.26H4.031V5.625h3.75c.517 0 .938-.42.938-.937V.938h11.25v20.25Z" />
    <path d="M17.625 8.906h-9.14a.469.469 0 0 0 0 .938h9.14a.469.469 0 0 0 0-.938ZM17.625 11.017H6.375a.469.469 0 0 0 0 .937h11.25a.469.469 0 0 0 0-.937ZM6.375 6.797a.469.469 0 0 0 0 .937h11.25a.469.469 0 0 0 0-.937H6.375ZM12 13.126H6.375a.469.469 0 1 0 0 .938H12a.469.469 0 0 0 0-.938ZM6.375 9.844a.469.469 0 0 0 0-.938.469.469 0 1 0 0 .938Z" />
  </svg>
);

export default DocumentDownload;
